import React from 'react';
import PropTypes from 'prop-types';

export default class ClipboardIcon extends React.Component {

    componentDidMount() {
        const clipboard = new Clipboard('.js-clipboard');
        let timer = null;
        clipboard.on('success', function (e) {
            $(e.trigger).addClass('is-active');
            if (timer !== null) {
                clearTimeout(timer);
            }
            timer = setTimeout(function () {
                $(e.trigger).removeClass('is-active');
            }, 750);
        });
    }

    render() {
        return (
            <a href="javascript:;" className="js-clipboard path--color" data-clipboard-text={this.props.text}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 15" className="icon">
                    <path
                        className="path--color"
                        d="M9.8 1h-1C8.4.4 7.7 0 7 0H5c-.7 0-1.4.4-1.7 1h-1C1 1 0 2 0 3.3v9.3C0 14 1 15 2.2 15h7.5c1.2 0 2.2-1 2.2-2.3V3.3C12 2 11 1 9.8 1zm.2 11.7c0 .2-.1.3-.2.3H2.2c-.1 0-.2-.1-.2-.3V3.3c0-.2.1-.3.2-.3h1c.3.6 1 1 1.7 1h2c.7 0 1.4-.4 1.7-1h1c.3 0 .4.1.4.3v9.4z"
                    />
                </svg>
            </a>
        )
    }
}

ClipboardIcon.propTypes = {
    text: PropTypes.string.isRequired
};
